export const FETCH_APPDATA_REQUESTING = "FETCH_APPDATA_REQUESTING"
export const FETCH_APPDATA_SUCCESSED = "FETCH_APPDATA_SUCCESSED"
export const FETCH_APPDATA_FAILED = "FETCH_APPDATA_FAILED"

export const GET_USERDETAILS = 'GET_USERDETAILS';
export const GET_USERDETAILS_SUCCESSED = 'GET_USERDETAILS_SUCCESSED';
export const GET_USERDETAILS_FAILED = 'GET_USERDETAILS_FAILED';

export const GET_CHALLENGEQUESTIONS = 'GET_CHALLENGEQUESTIONS';
export const GET_CHALLENGEQUESTIONS_SUCCESSED = 'GET_CHALLENGEQUESTIONS_SUCCESSED';
export const GET_CHALLENGEQUESTIONS_FAILED = 'GET_CHALLENGEQUESTIONS_FAILED';

export const UDPATE_ACCOUNT_ACTIVATE_DATA = 'UDPATE_ACCOUNT_ACTIVATE_DATA'
export const UDPATE_ACCOUNT_ACTIVATE_DATA_SUCCESSED = 'UDPATE_ACCOUNT_ACTIVATE_DATA_SUCCESSED'

export const CHECK_ACTIVATION = 'CHECK_ACTIVATION';
export const CHECK_ACTIVATION_SUCCESSED = 'CHECK_ACTIVATION_SUCCESSED';
export const CHECK_ACTIVATION_FAILED = 'CHECK_ACTIVATION_FAILED';

export const USER_ACTIVATION = 'USER_ACTIVATION';
export const USER_ACTIVATION_SUCCESSED = 'USER_ACTIVATION_SUCCESSED';
export const USER_ACTIVATION_FAILED = 'USER_ACTIVATION_FAILED';


export const GET_USERINFO = 'GET_USERINFO';
export const GET_USERINFO_SUCCESSED = 'GET_USERINFO_SUCCESSED';
export const GET_USERINFO_FAILED = 'GET_USERINFO_FAILED';

export const SAVE_SECURITYQUESTIONS = 'SAVE_SECURITYQUESTIONS';
export const SAVE_SECURITYQUESTIONS_SUCCESSED = 'SAVE_SECURITYQUESTIONS_SUCCESSED';
export const SAVE_SECURITYQUESTIONS_FAILED = 'SAVE_SECURITYQUESTIONS_FAILED';

export const UPDATE_USERINFO = 'UPDATE_USERINFO'
export const UPDATE_USERINFO_SUCCESSED = 'UPDATE_USERINFO_SUCCESSED'


export const GET_RESETPASSWORD_USERINFO = 'GET_RESETPASSWORD_USERINFO';
export const GET_RESETPASSWORD_USERINFO_SUCCESSED = 'GET_RESETPASSWORD_USERINFO_SUCCESSED';
export const GET_RESETPASSWORD_USERINFO_FAILED = 'GET_RESETPASSWORD_USERINFO_FAILED';

export const SAVE_RESETPASSWORD = 'SAVE_RESETPASSWORD';
export const SAVE_RESETPASSWORD_SUCCESSED = 'SAVE_RESETPASSWORD_SUCCESSED';
export const SAVE_RESETPASSWORD_FAILED = 'SAVE_RESETPASSWORD_FAILED';

export const UPDATE_RESETPASSWORD_USERINFO = 'UPDATE_RESETPASSWORD_USERINFO'
export const UPDATE_RESETPASSWORD_USERINFO_SUCCESSED = 'UPDATE_RESETPASSWORD_USERINFO_SUCCESSED'


export const GET_CHANGEPASSWORD_USERINFO = 'GET_CHANGEPASSWORD_USERINFO';
export const GET_CHANGEPASSWORD_USERINFO_SUCCESSED = 'GET_CHANGEPASSWORD_USERINFO_SUCCESSED';
export const GET_CHANGEPASSWORD_USERINFO_FAILED = 'GET_CHANGEPASSWORD_USERINFO_FAILED';

export const SAVE_CHANGEPASSWORD = 'SAVE_CHANGEPASSWORD';
export const SAVE_CHANGEPASSWORD_SUCCESSED = 'SAVE_CHANGEPASSWORD_SUCCESSED';
export const SAVE_CHANGEPASSWORD_FAILED = 'SAVE_CHANGEPASSWORD_FAILED';

export const UPDATE_CHANGEPASSWORD_USERINFO = 'UPDATE_CHANGEPASSWORD_USERINFO'
export const UPDATE_CHANGEPASSWORD_USERINFO_SUCCESSED = 'UPDATE_CHANGEPASSWORD_USERINFO_SUCCESSED'



export const GET_EXPIREDPASSWORD_USERINFO = 'GET_EXPIREDPASSWORD_USERINFO';
export const GET_EXPIREDPASSWORD_USERINFO_SUCCESSED = 'GET_EXPIREDPASSWORD_USERINFO_SUCCESSED';
export const GET_EXPIREDPASSWORD_USERINFO_FAILED = 'GET_EXPIREDPASSWORD_USERINFO_FAILED';

export const SAVE_EXPIREDPASSWORD = 'SAVE_EXPIREDPASSWORD';
export const SAVE_EXPIREDPASSWORD_SUCCESSED = 'SAVE_EXPIREDPASSWORD_SUCCESSED';
export const SAVE_EXPIREDPASSWORD_FAILED = 'SAVE_EXPIREDPASSWORD_FAILED';

export const UPDATE_EXPIREDPASSWORD_USERINFO = 'UPDATE_EXPIREDPASSWORD_USERINFO'
export const UPDATE_EXPIREDPASSWORD_USERINFO_SUCCESSED = 'UPDATE_EXPIREDPASSWORD_USERINFO_SUCCESSED'


export const VERIFY_EMAIL = 'VERIFY_EMAIL'
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS'
export const VERIFY_EMAIL_FAIL = 'VERIFY_EMAIL_FAIL'